import { profileVerified } from "assets";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "components/app/dialog/dialog";
import ImageUrlProfileStory from "components/app/image-url/ImageUrlProfileStory";
import SearchBar from "components/app/search-bar/SearchBar";
import { Skeleton } from "components/ui/skeleton";

import { Loader, X } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { AppLog } from "services";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";

interface DialogProps {
  setItemShopPermissionSearchUser: any;
  onUploadSuccess: ({ res }: { res: any }) => void;
  getShopPermissionSearchUser: any;
  itemShopPermissionSearchUser: any;
  isOpenDialogAddUser: boolean;
  setIsOpenDialogAddUser: (value: boolean) => void;
  ShopEmployeeDetail: any;
  loadingGetUser: boolean;
}
export default function DailogAddUserAccountId({
  setItemShopPermissionSearchUser,
  onUploadSuccess,
  getShopPermissionSearchUser,
  itemShopPermissionSearchUser,
  isOpenDialogAddUser,
  setIsOpenDialogAddUser,
  ShopEmployeeDetail,
  loadingGetUser,
}: DialogProps) {
  const { token } = useAppSelector((state) => state.auth);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const shopId = searchParams.get("id");
  const [page, setPage] = useState(1); // or use scroll_tag if API uses that
  const scrollTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  const [isFetching, setIsFetching] = useState(false);
  const [searchTextUser, setSearchTextUser] = useState<string>("");

  useEffect(() => {
    if (isOpenDialogAddUser) {
      getShopPermissionSearchUser(searchTextUser);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTextUser]);

  const fetchMoreUser = async () => {
    setIsFetching(true);
    try {
      const url = `${RouteApi.getShopPermissionSearchUser}token=${token}`;
      const data = {
        shop_id: shopId,
        search_text: searchTextUser,
        page: page + 1,
      };
      const response = await RequestApi(url, { data });

      if (response.status === "success") {
        setItemShopPermissionSearchUser({
          ...itemShopPermissionSearchUser,
          data: [...(itemShopPermissionSearchUser?.data || []), ...response?.users?.data],
        });
        setPage((prev) => prev + 1);
      }
    } catch (error) {
      AppLog.show({
        message: `[fetchMoreData]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      setIsFetching(false);
    }
  };

  const handleScrollCommittee = () => {
    if (scrollTimeoutRef.current) {
      clearTimeout(scrollTimeoutRef.current);
    }
    scrollTimeoutRef.current = setTimeout(() => {}, 500);
    const container = scrollContainerRef.current;
    if (!container || isFetching) return;

    const { scrollTop, scrollHeight, clientHeight } = container;

    if (scrollTop + clientHeight >= scrollHeight - 100) {
      fetchMoreUser();
    }
  };
  const [loadingButtonIndex, setLoadingButtonIndex] = useState<number | null>(null);
  const [clickedButtons, setClickedButtons] = useState<number[]>([]);

  const handleClick = async (item: any) => {
    setLoadingButtonIndex(item.id);
    onUploadSuccess({ res: item });
    await new Promise((resolve) => setTimeout(resolve, 500));
    setClickedButtons((prev) => [...prev, item.id]);
    setLoadingButtonIndex(null);
    setIsOpenDialogAddUser(false);
  };
  return (
    <Dialog open={isOpenDialogAddUser}>
      <DialogContent isShowBtnXClose={false} className={`max-w-full lg:max-w-[600px]  h-[calc(100vh-80px)] py-2 px-0 flex flex-col p-4 overflow-auto`}>
        <DialogHeader>
          <DialogTitle>FlipFlop Account Link </DialogTitle>
          <DialogDescription>Search FlipFlop account's name, click "Link" button to connect integration.</DialogDescription>
          <div
            className="absolute flex items-center justify-center right-4 top-1 z-40 cursor-pointer rounded-full bg-gray-200 dark:bg-accent w-[28px] h-[28px]"
            onClick={() => {
              setIsOpenDialogAddUser(false);
            }}
          >
            <X />
          </div>
        </DialogHeader>
        {/* ref={scrollContainerRef} onScroll={handleScrollCommittee} */}
        <div className=" w-full gap-3 h-full overflow-y-auto">
          <div className="flex flex-col pe-3 h-full">
            <div className="sticky top-[-1px] dark:bg-[#020817] left-0 py-2 px-1 z-10  bg-white">
              <div className="flex-1">
                <div className="relative">
                  <SearchBar
                    onValueChange={(value) => {
                      setSearchTextUser(value);
                    }}
                  />
                </div>
              </div>
            </div>
            {loadingGetUser ? (
              <div>
                {Array.from({ length: 11 }).map((_, index) => (
                  <div key={index} className="flex justify-between items-center m-2 ">
                    <div className="flex items-center space-x-4">
                      <Skeleton className="h-12 w-12 rounded-full" />
                      <div className="space-y-2">
                        <Skeleton className="h-4 w-[150px]" />
                        <Skeleton className="h-2 w-[160px]" />
                      </div>
                    </div>
                    <Skeleton className="h-7 w-[90px] rounded-md" />
                  </div>
                ))}
              </div>
            ) : (
              <div
                ref={scrollContainerRef}
                onScroll={handleScrollCommittee}
                className={`w-full h-full ${searchTextUser !== "" && "min-h-[300px]"}  space-y-2 mt-4 overflow-x-hidden pe-3`}
              >
                {itemShopPermissionSearchUser?.data?.map((item: any, index: number) => {
                  return (
                    <div key={index} className="flex justify-between items-center">
                      {searchTextUser !== "" && (
                        <>
                          <div className="flex flex-row space-x-2 w-full items-center">
                            <ImageUrlProfileStory user={item} className="w-14 h-14 shrink-0" isLinkProfile={true} />

                            <div className="flex w-full max-w-full flex-row justify-between items-center">
                              <div className="flex flex-col max-w-full w-full">
                                <div className="flex items-center space-x-2 max-w-full">
                                  <p className="text-sm font-medium line-clamp-2 overflow-hidden">{item.name}</p>

                                  {item.is_verified === "Yes" && <img src={profileVerified} alt="" className="w-[15px] h-[15px]" />}
                                </div>

                                <div className="flex items-center space-x-2 max-w-full">
                                  <p className="text-xs text-muted-foreground line-clamp-2 overflow-hidden">
                                    {`${item.no_of_follower ? `${item.no_of_follower} Followers` : ""}
                                                      ${item.no_of_like ? `• ${item.no_of_like} Likes` : ""}
                                                  `}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <button
                            key={item.id}
                            onClick={() => handleClick(item)}
                            className={`px-5 w-[70px] py-1 text-white rounded-full flex items-center justify-center text-sm font-semibold
                       ${
                         loadingButtonIndex === item.id
                           ? "bg-blue-500"
                           : ShopEmployeeDetail?.employee_account_id === item.account_id
                           ? "bg-gray-500 cursor-not-allowed"
                           : "bg-blue-500"
                       }
                        `}
                          >
                            {loadingButtonIndex === item.id ? <Loader className="animate-spin size-5" /> : "Link"}
                          </button>
                        </>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
          {/* <ScrollBar orientation="vertical" /> */}
        </div>
        <DialogFooter></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
